/**
 * pc端路由
 */
export default [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页'
    },
    component: () =>
        import('@/views/pc/home')
  },
  {
    path: '/antiFake',
    name: 'antiFake',
    mata: {
      title: '防伪溯源'
    },
    component: () =>
        import('@/views/pc/antiFake')
  },
  {
    path: '/environmentalProtection',
    name: 'environmentalProtection',
    meta: {
      title: '环保认证'
    },
    component: () =>
        import('@/views/pc/environmentalProtection')
  },
  {
    path: '/digitalMarketing',
    name: 'digitalMarketing',
    meta: {
      title: '数字营销'
    },
    component: () =>
        import('@/views/pc/digitalMarketing')
  },
  {
    path: '/cooperationCase',
    name: 'cooperationCase',
    meta: {
      title: '合作案例'
    },
    component: () =>
        import('@/views/pc/cooperationCase')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    meta: {
      title: '关于我们'
    },
    component: () =>
        import('@/views/pc/aboutUs')
  },
  {
    path: '/backgroundLogin',
    name: 'backgroundLogin',
    meta: {
      title: '后台登录'
    },
    component: () =>
        import('@/views/pc/backgroundLogin')
  },
  {
    path: '/alliedMember',
    name: 'alliedMember',
    meta: {
      title: '联盟成员'
    },
    component: () =>
        import('@/views/pc/alliedMember')
  },
  {
    path: '/validateCodeModule',
    component: () =>
        import('@/components/pc/module'),
    children: [
      {
        path: '',
        name: 'antiCounterfeitingQuery',
        meta: {
          title: '防伪查询'
        },
        component: () =>
            import('@/views/pc/validateCode/antiCounterfeitingQuery')
      }, {
        path: 'validateCode',
        name: 'validateCode',
        mata: {
          title: '验证防伪码'
        },
        component: () =>
            import('@/views/pc/validateCode/validateCode')
      }, {
        path: 'resultState',
        name: 'resultState',
        mata: {
          title: '验证结果页'
        },
        component: () =>
            import('@/views/pc/validateCode/resultState')
      }
    ]
  },
  {
    path: '/environmentalCertificationInquiry',
    name: 'environmentalCertificationInquiry',
    meta: {
      title: '环保认证查询'
    },
    component: () =>
        import('@/views/pc/environmentalCertificationInquiry')
  }
]



// WEBPACK FOOTER //
// ./src/router/pc.js